export default "__VITE_ASSET__CP38Vxth__"